import { Routes } from '@angular/router';
import { InternalGuard } from '../../../core/auth/guards/auth.guard';
import { firebaseInitializerResolver } from '../../../shared/services/firebase-initializer.resolver';
import { RidesBoardLayoutComponent } from './rides-board-layout.component';

export const RidesBoardRoutes: Routes = [
  {
    path: 'rides-board',
    component: RidesBoardLayoutComponent,
    canActivate: [InternalGuard],
    resolve: {
      firebaseInitialized: firebaseInitializerResolver,
    },
  },
];
